module.exports = __webpack_public_path__ + "Personal-Accident-gray.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/Personal-Accident-gray.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/Personal-Accident-gray.png
// module chunks = 10